import axios from "axios";
import { Api } from "./Api";
import { Export } from "../models/Export";
import FileUtils from "../utils/FileUtils";

export class ExportApi extends Api {
    constructor() {
        super("export");
    }

    create(type: string, params?: Object): Promise<Export> {
        return axios
            .post(this.apiUrl, { type: type, params: params })
            .then(function (response) {
                return new Export(response.data.data);
            });
    }

    get(id: number): Promise<Export> {
        return axios.get(this.apiUrl + id).then(function (response) {
            return new Export(response.data.data);
        });
    }

    download(id: number, fallbackFilename: string = "export"): Promise<any> {
        // Fichier reçu en flux binaire (auparavant encodé en base64 dans du
        // JSON, décodé sur le thread principal).
        return axios
            .get(this.apiUrl + id + "/download", { responseType: "blob" })
            .then(function (response) {
                const disposition = response.headers["content-disposition"] || "";
                const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
                const plain = /filename="?([^";]+)"?/i.exec(disposition);
                const filename = utf8
                    ? decodeURIComponent(utf8[1])
                    : plain
                    ? plain[1]
                    : fallbackFilename;
                FileUtils.downloadBlob(response.data, filename);
                return response;
            });
    }
}
